/* globals $ */
/**
 * To apply the calendar to multiple dependant inputs. Use the init() method to initialize the class, the params passed will override the default params
 */
window.Calendar = function(params) {
    'use strict';

    this.searchMinDate = {
        today: new Date()
    };
    this.searchMaxDate = {
        today: new Date()
    };

    this.calendar_class = '.search-calendar';
    this.format = 'yy-mm-dd';
    this.input_count = 'yy-mm-dd';
    this.min_days_diff = 0;
    this.max_days_diff = 330;
    this.start_day_limit = 0;
    this.language = params.language || 'en';
    this.focused = false;

    // selected dates
    this.selected_dates = [];
    this.selected_date_class = 'ui-state-selected';
    this.hovered_dates_class = 'ui-state-to-hover';

    this._setDefaultValues = function() {
        this.searchMinDate = {
            today: new Date()
        };
        this.searchMaxDate = {
            today: new Date()
        };

        //this.calendar_class = '.search-calendar';
        this.format = 'yy-mm-dd';
        this.input_count = 'yy-mm-dd';
        this.min_days_diff = 0;
        this.max_days_diff = 330;
        this.start_day_limit = 0;
    };

    // be sure to reset on change of booking type
    this.resetMinDate = function() {
        if (!this.searchMinDate[this.calendar_class]) {
            this.searchMinDate[this.calendar_class] = {};
        }

        var parent = this;
        var date_patt = /^([\d]{4})-([\d]{2})-([\d]{2})$/;
        var previousSegmentCurrentDate;
        $(this.calendar_class).each(function(i) {
            if (i > 0) {
                previousSegmentCurrentDate = $($(parent.calendar_class + ':eq(' + (i - 1) + ')')).val();

                if (previousSegmentCurrentDate) {
                    var matches = date_patt.exec(previousSegmentCurrentDate);
                    if (matches !== null) {
                        parent.searchMinDate[parent.calendar_class][i] = new Date(matches[1], (parseInt(matches[2], 10) - 1), matches[3]);

                        // Apply the min_days_diff
                        parent.searchMinDate[parent.calendar_class][i].setDate(
                            parent.searchMinDate[parent.calendar_class][i].getDate() + parent.min_days_diff
                        );

                    }
                    else {
                        parent.searchMinDate[parent.calendar_class][i] = parent.searchMinDate.today;
                    }
                }
            }
            else {
                parent.searchMinDate[parent.calendar_class][i] = parent.searchMinDate.today;
            }

            // if dates overlap, set next 7 days in the future
            // @disabled
            var next_selector = parent.calendar_class + ':eq(' + (i + 1) + ')';
            if (false && $(next_selector).length && $(next_selector).datepicker('getDate')) {
                if ($(this).datepicker('getDate') > $(next_selector).datepicker('getDate')) {
                    var new_date = $(next_selector).datepicker('getDate');
                    new_date.setDate(new_date.getDate() + 7);

                    // make sure next date doest overlap with the following
                    if (!$(parent.calendar_class + ':eq(' + (i + 2) + ')').val() || ($(parent.calendar_class + ':eq(' + (i + 2) + ')').val() && new_date < $(parent.calendar_class + ':eq(' + (i + 2) + ')').datepicker('getDate'))) {
                        $(next_selector).datepicker('setDate', new_date);
                    }
                }
            }

            $(this).datepicker('option', 'minDate', parent.searchMinDate[parent.calendar_class][i]);
        });
    };

    this.resetMaxDate = function() {
        if (!this.max_days_diff) {
            return;
        }

        if (!this.searchMaxDate[this.calendar_class]) {
            this.searchMaxDate[this.calendar_class] = {};
        }

        var parent = this;
        var date_patt = /^([\d]{4})-([\d]{2})-([\d]{2})$/;
        var previousSegmentCurrentDate;
        $(this.calendar_class).each(function(i) {
            if (i > 0) {
                previousSegmentCurrentDate = $($(parent.calendar_class + ':eq(' + (i - 1) + ')')).val();

                if (previousSegmentCurrentDate) {
                    var matches = date_patt.exec(previousSegmentCurrentDate);
                    if (matches !== null) {
                        parent.searchMaxDate[parent.calendar_class][i] = new Date(matches[1], (parseInt(matches[2], 10) - 1), matches[3]);

                        // Apply the min_days_diff
                        if (parent.max_days_diff !== null) {
                            parent.searchMaxDate[parent.calendar_class][i].setDate(
                                parent.searchMaxDate[parent.calendar_class][i].getDate() + parent.max_days_diff
                            );
                        }
                        else {
                            parent.searchMaxDate[parent.calendar_class][i] = parent.searchMaxDate.today;
                        }

                    }
                    else {
                        parent.searchMaxDate[parent.calendar_class][i] = parent.searchMaxDate.today;
                    }
                }
            }
            else {
                parent.searchMaxDate[parent.calendar_class][i] = parent.searchMaxDate.today;
            }

            $(this).datepicker('option', 'maxDate', parent.searchMaxDate[parent.calendar_class][i]);
        });
    };

    // Init
    this._setDefaultValues();

    var today = new Date();

    // override the default params
    for (var param_name in params) {
        if (params.hasOwnProperty(param_name) && typeof this[param_name] !== 'undefined') {
            this[param_name] = params[param_name];
        }
    }

    this.input_count = $(this.calendar_class).length;

    this.searchMinDate.today = new Date(today.getFullYear(), today.getMonth(), today.getDate() + this.start_day_limit);
    this.searchMaxDate.today = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() + this.start_day_limit);
    this.resetMinDate();
    this.resetMaxDate();

    //$(this.calendar_class).datepicker('destroy');

    var parent = this;
    var options = {
        showAnim: 'fadeIn',
        dateFormat: parent.format,
        minDate: parent.searchMinDate.today,
        showCurrentAtPos: 0,
        numberOfMonths: 2,
        beforeShow: function() {
            if (parent.focused) {
                parent.focused = false;
                return false;
            }
            setTimeout(function() {
                $('#ui-datepicker-div').css({'z-index': 30, 'width': 'auto'});
            }, 0);

        },
        onSelect: function(a, b) {
            if (!parent.searchMinDate[parent.calendar_class]) {
                parent.searchMinDate[parent.calendar_class] = {};
            }

            // update the min dates for all calendars
            parent.resetMinDate();
            parent.resetMaxDate();
            // try to focus on the date input tab
            parent.focused = true;
            $('#' + b.id).focus();
            if ($(this).attr('readonly')) {
                $(this).trigger('change');
            }
            // find next input, compare, delete if necessary, and update
            $(parent.calendar_class).each(function(i) {
                if (b.id === $(this).attr('id')) {
                    parent.selected_dates[i] = {'date': Date.parse(a), 'id': b.id};
                }
            });
        },
        beforeShowDay: function(date, inMonth) {
            if (parent.selected_dates.length >= 1) {
                var date_parsed = Date.parse($.datepicker.formatDate(parent.format, date));
                // loop through the selected dates
                for (var i = 0; i < parent.selected_dates.length; i++) {
                    // check if the dates are set
                    if (parent.selected_dates[i]) {
                        if (parent.selected_dates[i].date === date_parsed) {
                            return [true, parent.selected_date_class, ''];
                        }
                        else if (parent.selected_dates.length >= 2) { // two or more dates
                            if (parent.selected_dates[i + 1]) { // check for next date
                                if (date_parsed < parent.selected_dates[i + 1].date) {
                                    // simulate hover effect
                                    return [true, parent.hovered_dates_class, ''];
                                }
                            }
                        }
                    }
                }
            }
            return [true, '', ''];
        }
    };

    // mobile we show 1 month
    if ($(window).width() <= 480) {
        options.numberOfMonths = 1;
    }

    if (parent.max_days_diff) {
        //parent.searchMaxDate.today = new Date((today.getFullYear() + 1), today.getMonth(), today.getDate());
        parent.searchMaxDate.today = new Date((today.getFullYear()), today.getMonth(), today.getDate() + 330); // 330 days
        options.maxDate = parent.searchMaxDate.today;
    }

    // set the language locale
    $.datepicker.setDefaults($.datepicker.regional[parent.language]);

    // apply the calculated min/max dates
    $(this.calendar_class).each(function(cal_pos, e) {
        $(this).datepicker(options);

        // reset min date
        //$(this).datepicker('option', 'minDate', parent.searchMinDate[parent.calendar_class][cal_pos]);

        if (parent.max_days_diff) {
            $(this).datepicker('option', 'maxDate', parent.searchMaxDate[parent.calendar_class][cal_pos]);
        }
    });

    // reset dates for one way flight types
    this.resetDates = function() {
        $(document).find('td').removeClass('ui-state-over ' + parent.selected_date_class + ' ' + parent.hovered_dates_class);
        for (var i = 1; i < parent.selected_dates.length; i++) {
            parent.selected_dates[i].date = '';
            parent.selected_dates[i].id = '';
        }
    };
};
